// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CloseSquareOutlinedSvg from "@fishx/icons-svg/es/asn/CloseSquareOutlined";
import FishxIcon from '../components/FishxIcon';

var CloseSquareOutlined = function CloseSquareOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: CloseSquareOutlinedSvg
  }));
};

CloseSquareOutlined.displayName = 'CloseSquareOutlined';
export default React.forwardRef(CloseSquareOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/CloseSquareOutlined.js
// module id = 2244
// module chunks = 0